import { render, staticRenderFns } from "./ChooseProductInput.vue?vue&type=template&id=56511ebe&scoped=true"
import script from "./ChooseProductInput.vue?vue&type=script&lang=js"
export * from "./ChooseProductInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56511ebe",
  null
  
)

export default component.exports